import PageHeaderRoot from './PageHeaderRoot';
import PageSummary from './PageSummary';

const PageHeaderContact = () => {
  return (
    <PageHeaderRoot
      variant="contact"
      paper
      afterCol={<PageSummary variant="h4" />}
      GridProps={{ cx: { rowGap: 'md', pY: '5xl' } }}
    />
  );
};

export default PageHeaderContact;
